<template>
    <v-main>
        <v-layout fill-height column>
            <v-container flex-fill fluid>
                <div class="d-flex flex-column justify-center align-center flex-1 mb-10">
                    <img :src="getImage('ic_check.svg')" class="mb-5">
                    <div class="fs-18 blueGrayDarken4--text fw-700 line-height-1  mb-8">결제가 완료되었습니다.</div>
                    <v-btn plain class="btn-purchase-history" @click="moveHistoryPage">구매내역보기</v-btn>
                </div>
                <div class="purchase-info">
                    <div class="title mb-2"><span style="height: auto;" class="badge mr-2" v-text="ordDetail.goodsClsfNm"></span> {{ordDetail.goodsNm}}</div>
                    <div class="fs-16 fw-700 primary--text" v-if="ordDetail.goodsClsfNm === '티켓'">{{ ordDetail.paymentAmt }}원</div>
                    <div class="fs-16 fw-700 primary--text" v-if="ordDetail.goodsClsfNm === '물성'">{{ ordDetail.paymentAmt }} P</div>
                    <div class="des">{{ordDetail.goodsDscrt}}</div>
                </div>
            </v-container>
            <div class="footer-btns" >
                <BlackBtn str="확인" @click="moveIndexPage"/>
            </div>
        </v-layout>
    </v-main>
</template>
<script>
import BlackBtn from "@/components/btns/BlackBtn";
import store from '@/store'
export default {
    data: () => ({
        goodsNo:null,
        ordDetail:{},
        goodsType:null,
        isFirst: true,
        isChat: false,
        bfGuideNo: null,
        bfChaImgNo: null
    }),
    async created(){
        this.orderDetail();
    },
    components: {
        BlackBtn,
    },
    methods:{
        async orderDetail(){
            await store.dispatch('orderDetail', this.$_payload({ordNo:this.$route.query.ordNo}))
            .then(res => {
               console.log(res);
               this.ordDetail = res.data;
            })
            .catch(error => {
                console.error(error)

            })
            .finally(() => {
                this.findRealtalk()
            })
        },
        moveHistoryPage(){
            this.movePage("/fo/purchase/history")
        },
        moveIndexPage(){
            this.movePage("/");
        }
    }
}
</script>
<style lang="scss" scoped>
.container {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
}
.v-btn.btn-purchase-history {
    background: $color-sub;
    border-radius: 20px;
    color: var(--v-primary-base);
    font-size: 16px;
    font-weight: 400;
    height: 30px;
    padding: 0 23px;
}
.purchase-info {
    border-radius: 10px;
    box-shadow: 0 3px 10px rgba(0, 0, 0, 0.11);
    padding: 26px 30px;
    .title {
        display: flex;
        align-items: center;
        font-size: 18px !important;
        font-weight: 700;
    }
    .badge {
        border: 1px solid var(--v-primary-base);
        padding: 0 10px;
        height: 22px;
        font-size: 12px;
        font-weight: 500;
        color: var(--v-primary-base);
        background: transparent;
        border-radius: 20px;
        width: auto;
        flex-shrink: 0;
    }
    .des {
        font-size: 14px;
        color: #BEBEBE;
        margin-top: 2px;
    }
}
</style>
